import React, { FunctionComponent } from "react";

import { createQA } from "@multiweb/reactUtils";
import { LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS } from "../../locKeys";
import { MenuNavigationSectionType } from "../../navigation";
import { OpenedItem } from "../OpenedItem";

export type QuickAccessOpenedItemsComponentProps = {
    /** Seznam aktuálně otevřených formulářů. */
    openedFormsIds: readonly string[];
};

/** Vykresluje obsah části pro otevřené položky v menu Rychlého přístupu. */
export const QuickAccessOpenedItemsComponent: FunctionComponent<QuickAccessOpenedItemsComponentProps> = ({ openedFormsIds }) => (
    <div {...createQA("quick-access-opened")}>
        {openedFormsIds.map((formInstanceId) =>
            <OpenedItem key={formInstanceId} formInstanceId={formInstanceId} section={MenuNavigationSectionType.quickAccessOpened} qa={LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS} />,
        )}
    </div>
);
